import React from 'react';

const BADGE_SRC = '/logos/bolt-badge-black.png';

export default function BoltBadge() {
  return (
    <a
      href="https://bolt.new/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Powered by Bolt.new"
      className="fixed z-50 bottom-4 right-4 md:bottom-6 md:right-6"
      style={{
        width: '64px',
        height: '64px',
        minWidth: 40,
        minHeight: 40,
        maxWidth: '18vw',
        maxHeight: '18vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0.92,
        transition: 'opacity 0.2s',
      }}
      tabIndex={0}
    >
      <img
        src={BADGE_SRC}
        alt="Powered by Bolt.new"
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        draggable={false}
      />
    </a>
  );
} 